import React from 'react';
import { useInView } from 'react-intersection-observer';
import '../styles/Service.css';
import img1 from '../assets/delivervalues2.png';
import img2 from '../assets/clientuniverse.webp';
import img3 from '../assets/consultus1.png';
import parallaxImg from '../assets/Pic-18.jpeg';

// Child component for each service card
const ServiceCard = ({ service, index }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <div
      className={`card-section ${inView ? 'fade-up' : 'hidden'}`}
      data-title={service.title}
      style={{ '--i': index }}
      ref={ref}
    >
      <div className="card">
        <div className="flip-card__container">
          <div className="card-front">
            <div className={`card-front__tp card-front__tp--${index + 1}`}>
              <img
                src={service.image}
                alt={service.title}
                className="card-front__image"
              />
              <h2 className="card-front__heading">{service.title}</h2>
            </div>
          </div>
          <div className="card-back">
            <p className="card-back__description">{service.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Main Service component
const Service = () => {
  const servicesData = [
    {
      title: 'WE DELIVER VALUES',
      image: img1,
      description:
        'We provide value driven solutions in services through our multi-disciplinary engineering company. We subject and realise each of our goals through the state-of-the-art processes with highly skilled professionals. We are relentless in moving boundaries to keep our offerings wide-ranging for industrial and commercial facilities with an inclusivity to be a one-stop-source.',
    },
    {
      title: 'BUILDING US IN OUR CLIENT UNIVERSE',
      image: img2,
      description:
        'Apexcel incorporated with a mission to be a part of market in line with evolving trends and expectations through framed facets of our services. As we endeavour to build a commercial portfolio around our client space, our team adapts to meet their requirements individually one at a time.',
    },
    {
      title: 'CONSULT US TODAY',
      image: img3,
      description:
        'Send us a mail or give us a call, we assure you that we are good listeners when it comes to understanding and addressing your requirements of any size and capacity with our portfolio.',
    },
  ];

  return (
    <section className="services-container" id="service">
      <div className="services-grid">
        {servicesData.map((service, index) => (
          <ServiceCard key={index} service={service} index={index} />
        ))}
      </div>

      <div className="parallax-container">
        <div
          className="parallax-background"
          style={{ backgroundImage: `url(${parallaxImg})` }}
        />
      </div>
    </section>
  );
};

export default Service;
